import styled from "@emotion/styled/macro"
import { device } from "../components/Theme"

const Container = styled.div`
  max-width: 100%;
  padding: 0 24px;
  position: relative;
  overflow-x: hidden;

  @media ${device.md} {
    max-width: 732px;
    padding: 0;
    margin: 0 auto;
  }

  @media ${device.lg} {
    max-width: 956px;
    padding: 0;
    margin: 0 auto;
  }

  @media ${device.xl} {
    max-width: 1164px;
    padding: 0;
    margin: 0 auto;
  }

  @media ${device.xxl} {
    max-width: 1440px;
    padding: 0;
    margin: 0 auto;
  }
`

export { Container }
